<template>
  <div class="px-4">
    <div class="box max-w-xl mx-auto p-4">
      <div class="flex flex-col items-center justify-center">
        <p>{{ $t("my_linked_clubs") }}</p>
        {{ $t("automatic_link", { user_email: userEmail }) }}
      </div>
      <div class="flex items-center justify-center">
        <div class="relative w-60 input-component mt-12">
          <InputWhere
            :placeholder="$t('search_a_club_to_link')"
            :onlyOneSelect="true"
            :allowNearMe="false"
            :allowFavorites="false"
            @sendTenantToBooking="tenantSelected"
          />
        </div>
      </div>
      <div class="flex flex-col items-center justify-center mt-4">
        <p>{{ messageTitle }}</p>
        <p class="mt-4">{{ message }}</p>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { beautifyDate } from "@/helpers/dateHelper";
import { FindCustomerLinkedTenantsRequest, Tenant } from "models";
import InputWhere from "@/components/form/inputWhereSearch.vue";
import store from "@/store";
import { CustomerApi } from "@/service/CustomerApi";
import { capitalizeFirstLetter } from "@/helpers/dateHelper";
import CustomerHelper from "@/helpers/customerHelper";

export default defineComponent({
  name: "MyClubs",
  data() {
    return {
      start: 0,
      size: 50,
      messageTitle: "",
      message: "",
      userEmail:null
    };
  },
  props: ["customerId"],
  components: {
    InputWhere,
  },
  mounted() {
    this.userEmail = CustomerHelper.getUserEmail();
  },
  methods: {
    capitalizeFirstLetter,
    async tenantSelected(tenant: Tenant) {
      if (tenant === undefined) {
        return;
      }
      if (tenant.id == undefined) {
        return;
      }
      const request: FindCustomerLinkedTenantsRequest = {
        tenantId: tenant.id
      }
      this.loadData(request);
    },
    async loadData(request: FindCustomerLinkedTenantsRequest) {
      store.commit("setLoading", true);
      const response: any = await CustomerApi.findLinkedTenantsByCustomer(request);
      store.commit("setLoading", false);
      let tenantName = ""
      if(response?.data.length > 0){
        tenantName = response.data[0].name
        this.messageTitle = this.$t("linked")
        this.message = this.$t("club_link_find", { club_name:tenantName, user_email:this.userEmail})
        return
      }
      this.messageTitle = this.$t("sorry")
      this.message = this.$t("club_link_not_found", {user_email:this.userEmail})
    },
    getBeautifyDate(date: any) {
      return beautifyDate(date, true, false);
    },
  },
});
</script>
<style scoped>
.box {
  border-radius: 24px;
  background: var(--background-color-box);
}
</style>

